import { Container, Grid, Text, Link } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

function CloseAccountCantClose({ state }) {
  const { accountInfo } = state;

  return (
    <Grid rowsGap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="close-account-illustration" size="92" />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Sorry, we're unable to close your account
      </Text>
      <Container>
        <Text>
          We noticed that there is a balance owing on your{" "}
          {accountInfo.cardName}.<br />
        </Text>
        <Text margin="6 0 0 0">
          Your account balance has to be zero in order to close your account.
        </Text>
      </Container>
      <Container>
        <Link appearance="primary-button" href="/" newTab={false}>
          Go to overview
        </Link>
      </Container>
    </Grid>
  );
}

export { CloseAccountCantClose };
